import { render, staticRenderFns } from "./PaymentIcon.vue?vue&type=template&id=494b8dbc&scoped=true"
import script from "./PaymentIcon.vue?vue&type=script&lang=js"
export * from "./PaymentIcon.vue?vue&type=script&lang=js"
import style0 from "./PaymentIcon.vue?vue&type=style&index=0&id=494b8dbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494b8dbc",
  null
  
)

export default component.exports